import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

const milestones = [
  { year: '2018', title: '梦想起航', desc: '开云下载项目正式立项，核心团队组建完成，致力于打造安全高效的下载工具。' },
  { year: '2019', title: '初露锋芒', desc: '开云下载v1.0正式发布，凭借出色的下载速度和稳定性迅速获得10万用户。' },
  { year: '2020', title: '快速发展', desc: '用户数突破500万，推出macOS和Android版本，实现多端覆盖。' },
  { year: '2021', title: '安全升级', desc: '引入AI病毒检测引擎，首创五层安全防护体系，通过国家信息安全等级保护认证。' },
  { year: '2022', title: '亿级突破', desc: '累计用户突破1亿，日均下载量超过300万次，成为国内领先的下载管理平台。' },
  { year: '2023', title: '智能进化', desc: '推出AI智能分类和云端同步功能，发布iOS版本，实现全平台覆盖。' },
  { year: '2024', title: '生态构建', desc: '开放第三方插件平台，与50+主流软件厂商建立官方合作，丰富软件资源库。' },
  { year: '2025', title: '全球化布局', desc: '推出多语言版本，服务覆盖全球200+国家和地区，海外用户占比达到30%。' },
  { year: '2026', title: 'AI驱动', desc: '全面升级AI能力，推出智能推荐、语音控制等功能，持续引领下载工具行业发展。' },
];

const testimonials = [
  {
    name: '张先生',
    role: 'IT工程师',
    rating: 5,
    text: '作为IT从业者，我试用过市面上几乎所有的下载工具，开云下载的速度和稳定性是最让我满意的。尤其是它的批量任务管理和资源嗅探功能，大大提高了我日常工作的效率。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20avatar%20portrait%2C%20clean%20minimal%20style%2C%20warm%20friendly%20expression%2C%20neutral%20light%20background%2C%20professional%20headshot&width=80&height=80&seq=t-1&orientation=squarish',
  },
  {
    name: '李女士',
    role: '大学教师',
    rating: 5,
    text: '经常需要下载教学资料和学术论文，开云下载的断点续传功能真的很实用。有一次网络断了，恢复后自动继续下载，完全不用担心文件损坏。安全性方面也很让人放心。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20avatar%20portrait%2C%20clean%20minimal%20style%2C%20warm%20friendly%20expression%2C%20neutral%20light%20background%2C%20professional%20headshot&width=80&height=80&seq=t-2&orientation=squarish',
  },
  {
    name: '王同学',
    role: '研究生',
    rating: 5,
    text: '开云下载的AI分类功能太方便了！以前下载的文件乱七八糟的，现在下载完自动就分好了类。手机和电脑之间的传输也很快，强烈推荐给各位同学。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20avatar%20portrait%2C%20clean%20minimal%20style%2C%20friendly%20smile%2C%20neutral%20light%20background%2C%20professional%20headshot&width=80&height=80&seq=t-3&orientation=squarish',
  },
  {
    name: '赵总',
    role: '创业公司CEO',
    rating: 5,
    text: '我们公司50多人的团队都在用开云下载，专业版的云端同步功能让远程协作变得非常方便。性价比很高，一年才99块，比很多同类产品便宜太多了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20avatar%20portrait%2C%20clean%20minimal%20style%2C%20confident%20expression%2C%20neutral%20light%20background%2C%20professional%20headshot&width=80&height=80&seq=t-4&orientation=squarish',
  },
  {
    name: '陈女士',
    role: '自由设计师',
    rating: 4,
    text: '经常需要下载高清素材和设计资源，开云下载的大文件下载速度确实很快。唯一的小建议是希望能增加更多设计软件的官方下载入口。整体体验非常棒！',
    avatar: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20woman%20avatar%20portrait%2C%20clean%20minimal%20style%2C%20artistic%20expression%2C%20neutral%20light%20background%2C%20professional%20headshot&width=80&height=80&seq=t-5&orientation=squarish',
  },
  {
    name: '刘先生',
    role: '网管',
    rating: 5,
    text: '作为公司的网络管理员，我最看重的是安全性。开云下载的五层安全防护让我们很放心，从来没有出现过捆绑软件或病毒的问题。部署和管理也很方便。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20avatar%20portrait%2C%20clean%20minimal%20style%2C%20serious%20but%20friendly%2C%20neutral%20light%20background%2C%20professional%20headshot&width=80&height=80&seq=t-6&orientation=squarish',
  },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('contact_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      return;
    }
    setSubmitting(true);
    setFormError('');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9rg1qnnahb7382ovm00', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: unknown;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = (parsed as Record<string, unknown>)?.meta?.message as string
        || (parsed as Record<string, unknown>)?.message as string
        || (parsed as Record<string, unknown>)?.meta?.detail as string
        || responseText;
      if (res.ok && (parsed as Record<string, unknown>)?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Brand Intro */}
          <section className="mb-20">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-6">
              关于 <span className="text-primary-500">开云下载</span>
            </h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  <strong>开云下载</strong>成立于2018年，是国内领先的软件下载与文件管理平台。我们致力于为广大用户提供安全、快速、便捷的下载服务，让每一次下载都值得信赖。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  经过多年发展，开云下载已积累超过<strong className="text-primary-600">1.2亿</strong>注册用户，日均完成下载任务超500万次。我们的产品覆盖了Windows、macOS、Android和iOS四大平台，真正实现全终端无缝体验。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  我们始终坚持以用户体验为核心，不断投入研发资源进行技术创新。开云下载拥有业界领先的<strong>五层安全防护体系</strong>、P2P多线程加速引擎和AI智能分类系统，在下载速度、安全性和易用性三个维度持续引领行业标准。
                </p>
              </div>
              <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20tech%20office%20workspace%20with%20computer%20screens%20showing%20software%20interfaces%2C%20warm%20orange%20accents%2C%20collaborative%20team%20environment%2C%20clean%20minimalist%20design%2C%20bright%20natural%20lighting%2C%20professional%20atmosphere&width=800&height=600&seq=about-brand-001&orientation=landscape"
                  alt="开云下载团队"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </section>

          {/* Milestones */}
          <section className="mb-20">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-10 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
              <div className="flex flex-col gap-8">
                {milestones.map((m, i) => (
                  <div key={m.year} className={`relative flex items-start gap-6 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className="md:w-1/2 flex items-center gap-6 md:justify-end md:pr-10">
                      <div className={`flex-1 bg-background-50 rounded-xl border border-background-200/70 p-5 ${i % 2 === 0 ? '' : 'md:text-right'}`}>
                        <span className="inline-block text-sm font-bold text-primary-500 bg-primary-50 px-3 py-1 rounded-md mb-2">
                          {m.year}
                        </span>
                        <h3 className="font-semibold text-foreground-900 mb-1">{m.title}</h3>
                        <p className="text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
                      </div>
                    </div>
                    <div className="absolute left-[10px] md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 mt-6 z-10"></div>
                    <div className="md:w-1/2 md:pl-10"></div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="mb-20">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-10 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-accent-100 overflow-hidden flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <p className="font-semibold text-sm text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 bg-background-100 rounded-2xl p-8 md:p-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
                  联系我们
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-8">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们的客服团队将在24小时内回复您的消息。
                </p>
                <div className="flex flex-col gap-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</p>
                      <p className="text-sm text-foreground-600">support@kaiyunxiazai.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900 mb-1">客服热线</p>
                      <p className="text-sm text-foreground-600">400-888-0000</p>
                      <p className="text-xs text-foreground-500">周一至周日 9:00 - 21:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900 mb-1">公司地址</p>
                      <p className="text-sm text-foreground-600">北京市海淀区中关村科技园区创新大厦18层</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</p>
                      <p className="text-sm text-foreground-600">开云下载官方</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <h3 className="text-lg font-semibold text-foreground-900 mb-4">发送消息</h3>

                {formStatus === 'success' ? (
                  <div className="text-center py-12">
                    <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                      <i className="ri-check-line text-2xl text-accent-600"></i>
                    </div>
                    <p className="text-foreground-900 font-semibold mb-1">消息已发送！</p>
                    <p className="text-sm text-foreground-600">感谢您的留言，我们会在24小时内回复您。</p>
                  </div>
                ) : (
                  <form
                    onSubmit={handleSubmit}
                    data-readdy-form
                    className="flex flex-col gap-4"
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        姓名 <span className="text-red-400">*</span>
                      </label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        邮箱 <span className="text-red-400">*</span>
                      </label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        id="contact-subject"
                        name="subject"
                        type="text"
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                        placeholder="请输入消息主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        留言内容 <span className="text-red-400">*</span>
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                        placeholder="请输入您的留言内容（不超过500字）"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="contact_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    {formStatus === 'error' && formError && (
                      <p className="text-sm text-red-500">{formError}</p>
                    )}
                    <button
                      type="submit"
                      disabled={submitting}
                      className="w-full py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {submitting ? (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-loader-4-line animate-spin"></i>
                          发送中...
                        </span>
                      ) : (
                        '发送消息'
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </section>
        </div>

        {/* Schema.org */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于开云下载',
              description: '开云下载品牌介绍、发展历程、用户口碑与联系方式',
              url: 'https://www.kaiyunxiazai.com/about',
              isPartOf: { '@type': 'WebSite', name: '开云下载', url: 'https://www.kaiyunxiazai.com/' },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.kaiyunxiazai.com/' },
                { '@type': 'ListItem', position: 2, name: '关于我们' },
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: '开云下载',
              url: 'https://www.kaiyunxiazai.com/',
              description: '开云下载官方平台，提供最新版本安全极速下载服务',
              address: {
                '@type': 'PostalAddress',
                streetAddress: '中关村科技园区创新大厦18层',
                addressLocality: '北京',
                addressRegion: '海淀区',
                addressCountry: 'CN',
              },
              contactPoint: {
                '@type': 'ContactPoint',
                telephone: '+86-400-888-0000',
                email: 'support@kaiyunxiazai.com',
                contactType: 'customer service',
                areaServed: 'CN',
                availableLanguage: 'Chinese',
                hoursAvailable: [
                  { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'], opens: '09:00', closes: '21:00' },
                ],
              },
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}